import React, { Component } from "react";

export default class ExpCard extends Component {
    render() {
        return (
            <div className="educard exp rounded-lg">
                {/* <div className="h4 mb-0 px-1 text-right">
                    <i className="fa fa-briefcase"></i>
                </div> */}
                <div className="profession mb-0">{this.props.course}</div>
                <div className="edu-title">{this.props.details}</div>
                <hr className="rounded pt-1 w-50 ml-0" />
                <div className="edu-title">{this.props.date}</div>
            </div>
        );
    }
}
